import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, Typography, Edges, Backlinks } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar-graph.module.css'

export const SidebarGraph: FC<SidebarComponent> = ({ entity }) => (
  <div className={styles.container}>
    <Typography variant="caption">
      <Divider className={styles.divider}>Links</Divider>
      <Edges sourceId={entity.id} />
      <Divider className={styles.divider}>Backlinks</Divider>
      <Backlinks id={entity.id} />
    </Typography>
  </div>
)
